import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  show({ params: { id } }) {
    document.getElementById(id)?.showModal();
  }

  close({ currentTarget }) {
    currentTarget.closest("dialog").close();
  }
}
